import { isLocalhost } from "./isLocalhost";

export const getUrlFromLogoParameters = (
  logoParameters: string,
  idConcern: number
) => {
  if (!logoParameters) return null;

  const baseUrl = isLocalhost
    ? "https://secure.webtemp.no/cgi-win/test/jorgen/wtgetfile.exe"
    : "https://secure.webtemp.no/cgi-win/wtgetfile.exe";

  const url = new URL(baseUrl);

  const paramsFromSetting = new URLSearchParams(logoParameters);

  url.searchParams.set("k", idConcern.toString());
  url.searchParams.set("allow-cache", "1");
  url.searchParams.set("a", "publicdoc");

  if (paramsFromSetting.has("key")) {
    url.searchParams.set("key", paramsFromSetting.get("key"));
  }

  if (paramsFromSetting.has("i")) {
    url.searchParams.set("i", paramsFromSetting.get("i"));
  }

  return url.toString();
};
